import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [isAuthorized, setIsAuthorized] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");

    if (!token || !token.trim()) {
      setIsAuthorized(false);
      return;
    }

    // If no specific roles required, allow any authenticated user
    if (allowedRoles.length === 0) {
      setIsAuthorized(true);
      return;
    }

    // Check if user's role is in the allowed roles list (role 0 is Platform SuperAdmin)
    const userRole = Number(role);
    if (userRole === 0 || allowedRoles.includes(userRole)) {
      setIsAuthorized(true);
    } else {
      setIsAuthorized(false);
    }
  }, [allowedRoles]);

  if (isAuthorized === null) {
    // Still checking authorization
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (!isAuthorized) {
    // Redirect to login if not authenticated, or show access denied
    const token = localStorage.getItem("token");
    if (!token) {
      return <Navigate to="/" state={{ from: location }} replace />;
    }

    // User is authenticated but doesn't have the right role
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">You don't have permission to access this page.</p>
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;